<template>
    <div id="contenedor-main-listado-obras">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop :listadoObras="listadoObras"></desktop>
        </template>
        <template
            v-else>
            <mobile :listadoObras="listadoObras"></mobile>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoObras',
  props: {
    listadoObras: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
